import {
  LPTotalAmount,
  alpaPerBlock as getAlpaPerBlock,
  LPUserInfo as getUserlInfo,
} from '@/utils/web3';
import { alpaUnit, sqrt } from '@/utils/unit';
import { getFarmInfo } from '@/backend/requests';
import BigNumber from 'bignumber.js';

export const farmCardInfo = async (address: string, pool: number) => {
  const totalBloackNum = !!process.env.VUE_APP_BSC ? 10512000 : 2102400;

  if (!address) {
    return;
  }

  const [
    { data: farmInfo },
    totalAmount,
    alpaPerBlock,
    userInfo,
  ] = await Promise.all([
    getFarmInfo(pool),
    LPTotalAmount(pool),
    getAlpaPerBlock(),
    getUserlInfo(address, pool),
  ]);
  const LPPrice = new BigNumber(farmInfo.prices.lp_to_usd);

  const AlpaPrice = new BigNumber(farmInfo.prices.alpa_to_usd);

  // TODO(sh): alpaPerBlock = alpaPerBlock * (master chef allocPoint / (master chef allocPoint + squad allocPoint))
  //                        = alpaPerBlock * 0.8
  const totalAlpa = new BigNumber(alpaPerBlock)
    .multipliedBy(new BigNumber(totalBloackNum))
    .multipliedBy(AlpaPrice)
    .multipliedBy(0.56); // 0.56 = 0.7 * 0.8

  const totalDeposit = new BigNumber(totalAmount).multipliedBy(LPPrice);

  const totalApy =
    totalAmount !== '0'
      ? totalAlpa
          .dividedBy(new BigNumber(totalAmount).multipliedBy(LPPrice))
          .multipliedBy(100)
      : new BigNumber(0);

  const midEnergy = new BigNumber(farmInfo.pool.mid_energy);

  const maxEnergy = new BigNumber(farmInfo.pool.max_energy);

  const totalEnergyLP = alpaUnit(new BigNumber(farmInfo.pool.total_energy_lp));

  const midApy = totalEnergyLP.isGreaterThan(0)
    ? sqrt(midEnergy)
        .dividedBy(totalEnergyLP)
        .multipliedBy(totalAlpa)
        .dividedBy(LPPrice)
        .multipliedBy(100)
    : new BigNumber(0);

  const maxApy = totalEnergyLP.isGreaterThan(0)
    ? sqrt(maxEnergy)
        .dividedBy(totalEnergyLP)
        .multipliedBy(totalAlpa)
        .dividedBy(LPPrice)
        .multipliedBy(100)
    : new BigNumber(0);

  let userApy = new BigNumber(0);

  if (userInfo && userInfo.alpacaEnergy && totalEnergyLP.isGreaterThan(0)) {
    userApy = sqrt(new BigNumber(userInfo.alpacaEnergy))
      .dividedBy(totalEnergyLP)
      .multipliedBy(totalAlpa)
      .dividedBy(LPPrice)
      .multipliedBy(100);
  }

  return {
    totalDeposit,
    totalApy,
    midEnergy,
    maxEnergy,
    userEnergy: userInfo
      ? userInfo.alpacaEnergy === '0'
        ? 1
        : userInfo.alpacaEnergy
      : 1,
    midApy,
    maxApy,
    userApy,
  };
};
